export const TEMPLATE_DOCUMENTOS_LISTAR = "TEMPLATE_DOCUMENTOS_LISTAR";
export const TEMPLATE_DOCUMENTOS_OBTER = "TEMPLATE_DOCUMENTOS_OBTER";
export const TEMPLATE_DOCUMENTOS_SALVAR = "TEMPLATE_DOCUMENTOS_SALVAR";
export const TEMPLATE_DOCUMENTOS_RESTAURAR = "TEMPLATE_DOCUMENTOS_RESTAURAR";
export const TEMPLATE_DOCUMENTOS_PREVIEW_PDF =
  "TEMPLATE_DOCUMENTOS_PREVIEW_PDF";
